Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Brand", {
    enumerable: true,
    get: function() {
        return Brand;
    }
});
const _env = require("./env.cjs");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Brand {
    // eslint-disable-next-line max-statements
    static fromDef(brandDef, env, allMarkets, allSites) {
        const uid = brandDef.uid;
        const domain = brandDef.domain;
        const prodPlid = brandDef.prodPlid;
        let plid;
        switch(env){
            case _env.AtlasEnv.dev:
                plid = brandDef.devPlid ?? brandDef.prodPlid;
                break;
            case _env.AtlasEnv.test:
                plid = brandDef.testPlid ?? brandDef.prodPlid;
                break;
            case _env.AtlasEnv.ote:
                plid = brandDef.otePlid ?? brandDef.prodPlid;
                break;
            default:
                plid = brandDef.prodPlid;
        }
        const markets = brandDef.marketUids.map((marketUid)=>allMarkets.find((market)=>market.uid === marketUid));
        const defaultMarket = markets.find((market)=>market.uid === brandDef.defaultMarketUid);
        const marketByLocaleLookups = new Map();
        const marketByCountryLookups = new Map();
        const marketByLangLookups = new Map();
        markets.forEach((market)=>{
            marketByLocaleLookups.set(market.marketLocale.toLowerCase(), market);
            // Add market's lang to lang lookup, fallbacks take priority
            const lang = market.lang.toLowerCase();
            if (!marketByLangLookups.has(lang) || market.langFallback) {
                marketByLangLookups.set(lang, market);
            }
            market.countries.forEach((country)=>{
                const locale = `${market.lang}-${country.code}`.toLowerCase();
                marketByLocaleLookups.set(locale, market);
                if (country.defaultLang === market.lang) {
                    marketByCountryLookups.set(country.code.toLowerCase(), market);
                }
            });
        });
        const sites = brandDef.siteUids.map((siteUid)=>allSites.find((site)=>site.uid === siteUid));
        const defaultSite = sites.find((site)=>site.uid === brandDef.defaultSiteUid);
        const siteLookups = new Map();
        sites.forEach((site)=>{
            site.markets.forEach((market)=>{
                siteLookups.set(market.marketLocale.toLowerCase(), site);
            });
        });
        return new Brand(uid, domain, prodPlid, plid, markets, defaultMarket, sites, defaultSite, marketByLocaleLookups, marketByCountryLookups, marketByLangLookups, siteLookups);
    }
    static fromBrand(brand, plid) {
        return new Brand(`generic-${plid}`, brand.domain, plid, plid, [
            ...brand.markets
        ], brand.defaultMarket, [
            ...brand.sites
        ], brand.defaultSite, new Map(brand.marketByLocaleLookups), new Map(brand.marketByCountryLookups), new Map(brand.marketByLangLookups), new Map(brand.siteLookups));
    }
    findMarketByLocale(locale) {
        return this.marketByLocaleLookups.get(locale.toLowerCase());
    }
    resolveMarketByLocale(locale) {
        return this.marketByLocaleLookups.get(locale.toLowerCase()) ?? this.defaultMarket;
    }
    findMarketByCountryCode(countryCode) {
        return this.marketByCountryLookups.get(countryCode.toLowerCase());
    }
    findMarketByLang(lang) {
        return this.marketByLangLookups.get(lang.toLowerCase());
    }
    findSiteByLocale(locale) {
        return this.siteLookups.get(locale.toLowerCase());
    }
    resolveSiteByLocale(locale) {
        const market = this.resolveMarketByLocale(locale);
        return this.siteLookups.get(market.marketLocale.toLowerCase()) ?? this.defaultSite;
    }
    findSiteBySubDomainPath(subdomain, subpath = null) {
        return this.sites.find((site)=>{
            return site.subdomain.toLowerCase() === subdomain.toLowerCase() && site.subpath === (!subpath ? null : subpath.toLowerCase());
        });
    }
    getMarkets() {
        return this.markets.filter((market)=>!market.internal);
    }
    getAllMarkets() {
        return [
            ...this.markets
        ];
    }
    // eslint-disable-next-line max-params
    constructor(uid, domain, prodPlid, plid, markets, defaultMarket, sites, defaultSite, marketByLocaleLookups, marketByCountryLookups, marketByLangLookups, siteLookups){
        _define_property(this, "uid", void 0);
        _define_property(this, "domain", void 0);
        _define_property(this, "prodPlid", void 0);
        _define_property(this, "plid", void 0);
        _define_property(this, "markets", void 0);
        _define_property(this, "defaultMarket", void 0);
        _define_property(this, "sites", void 0);
        _define_property(this, "defaultSite", void 0);
        _define_property(this, "marketByLocaleLookups", void 0);
        _define_property(this, "marketByCountryLookups", void 0);
        _define_property(this, "marketByLangLookups", void 0);
        _define_property(this, "siteLookups", void 0);
        this.uid = uid;
        this.domain = domain;
        this.prodPlid = prodPlid;
        this.plid = plid;
        this.markets = markets;
        this.defaultMarket = defaultMarket;
        this.sites = sites;
        this.defaultSite = defaultSite;
        this.marketByLocaleLookups = marketByLocaleLookups;
        this.marketByCountryLookups = marketByCountryLookups;
        this.marketByLangLookups = marketByLangLookups;
        this.siteLookups = siteLookups;
    }
}
